import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "panel_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const panelApi = axios.create({ baseURL: API });

panelApi.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// FastAPI validation errors can be arrays/objects — always render a string.
export function apiError(detail, fallback = "Κάτι πήγε στραβά. Δοκιμάστε ξανά.") {
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return fallback;
}

export function useNoIndex(title = "Πίνακας Ελέγχου") {
  if (typeof document !== "undefined") {
    document.title = `${title} · Ιατρείο`;
    if (!document.querySelector('meta[data-panel-robots]')) {
      const m = document.createElement("meta");
      m.name = "robots";
      m.content = "noindex, nofollow";
      m.setAttribute("data-panel-robots", "1");
      document.head.appendChild(m);
    }
  }
}
